import { useState } from 'react';

export default function SecretPrompt({ onSubmit }) {
  const [value, setValue] = useState('');

  function handleSubmit(event) {
    event.preventDefault();
    if (!value.trim()) return;
    onSubmit(value.trim());
  }

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm rounded-2xl border border-cyan-100 bg-white p-6 shadow"
      >
        <h2 className="mb-1 text-base font-semibold text-slate-900">Kết nối Clone Provider</h2>
        <p className="mb-4 text-sm text-slate-500">
          Nhập admin secret của ak_clone_provider để tiếp tục. Secret chỉ lưu trong session hiện tại của trình duyệt.
        </p>
        <input
          type="password"
          autoFocus
          value={value}
          onChange={(event) => setValue(event.target.value)}
          placeholder="ADMIN_SECRET"
          className="mb-3 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-cyan-400"
        />
        <button
          type="submit"
          className="w-full rounded-lg bg-cyan-600 px-3 py-2 text-sm font-medium text-white hover:bg-cyan-700"
        >
          Kết nối
        </button>
      </form>
    </div>
  );
}
